'use strict';

require('./gold-file-list-item-widget');

const mmWidgets = require('./mm-widgets'),
	fileListItemsAreEqual = (item1, item2) => {
		return item1 === item2 || JSON.stringify(item1) === JSON.stringify(item2);
	},
	fileListsAreEqual = (list1, list2) => {
		if (!list1 && !list2) {
			return true;
		}
		if (!list1 || !list2) {
			return false;
		}
		if (list1.length !== list2.length) {
			return false;
		}
		if (!list1.length) {
			return true;
		}
		let areEqual = true;
		list1.forEach((item, index) => areEqual = areEqual && fileListItemsAreEqual(item, list2[index]));
		return areEqual;
	};

mmWidgets.fn.goldFileListWidget = function (config, goldFileListModel, authenticationModel, navigatorShim) {
	return mmWidgets.each(this, function () {
		let currentListType, displayedList = [];
		const element = this,
			listContainer = element.find('[data-mm-role~="fileListContainer"]'),
			listPropertyName = element.attr('data-mm-list-property-name') || 'fileList',
			template = element.find('[data-mm-role~=file-list-template]').remove();

		goldFileListModel.addEventListener('context', (context) => {
			if (context.preferences && context.preferences.listType) {
				if (currentListType) {
					element.removeClass(currentListType);
				}
				element.addClass(context.preferences.listType);
				currentListType = context.preferences.listType;
			}
			Promise.resolve()
			.then(() => {
				if (context.currentAction && ['listingFiles', 'refreshingFiles'].includes(context.currentAction)) {
					listContainer.empty();
				} else {
					const files = context[listPropertyName] || [],
						knownFiles = [];

					if (!files || files.length === 0) {
						listContainer.empty();
						displayedList = [];
					} else if (!fileListsAreEqual(displayedList, context[listPropertyName])) {
						listContainer.empty();
						displayedList = context[listPropertyName];
						return authenticationModel.getProfile()
						.then(profile => {
							const account = profile && profile.license && profile.license.account,
								subAccount = profile && profile.license && profile.license.subAccount;
							files.forEach(function (file) {
								if (!knownFiles.includes(file.url)) {
									knownFiles.push(file.url);
									template.clone()
									.goldFileListItemWidget(config.editorUrl, account, subAccount, file, goldFileListModel, navigatorShim)
									.appendTo(listContainer);

								}
							});
						});

					}
				}
			})
			.then(() => {
				element.trigger('context-end');
			});
		});

	});
};
